<template>
  <section class="advantage">
    <TheHeader />
    <section class="advantage__banner">
      <h1>Conheça os benefícios</h1>
    </section>

    <div class="limit-grid">
      <div class="advantage__wrapper">
        <div class="advantage__grid">
          <section class="advantage__grid__item" @click="goTo('saude')">
            <div class="advantage__grid__item__wrapper">
              <img src="@/assets/beneficios/saude.svg" alt />
              <h2>Saúde</h2>
            </div>
          </section>
          <section class="advantage__grid__item" @click="goTo('educacao')">
            <div class="advantage__grid__item__wrapper">
              <img src="@/assets/beneficios/educacao.svg" alt />
              <h2>Educação</h2>
            </div>
          </section>
          <section class="advantage__grid__item" @click="goTo('lazer')">
            <div class="advantage__grid__item__wrapper">
              <img src="@/assets/beneficios/lazer.svg" alt />
              <h2>Lazer</h2>
            </div>
          </section>
        </div>
        <div class="advantage__grid-content">
          <section
            :class="[
              'advantage__grid-content__item',
              { 'advantage__grid-content__item--active': itens.saude },
            ]"
            @click="goTo('saude')"
          >
            <p>
              São mais de 250 clínicas médicas e odontológicas e mais de 1.500
              exames a preços acessíveis para o seu bolso, além de descontos
              especiais em farmácias.
            </p>
          </section>
          <section
            :class="[
              'advantage__grid-content__item',
              { 'advantage__grid-content__item--active': itens.educacao },
            ]"
            @click="goTo('educacao')"
          >
            <p>
              Você pode impulsionar sua carreira com os cursos
              profissionalizantes e preparatórios do PreparaTODOS, além de
              descontos em mais de 67 universidades, escolas de idiomas e cursos
              técnicos.
            </p>
          </section>
          <section
            :class="[
              'advantage__grid-content__item',
              { 'advantage__grid-content__item--active': itens.lazer },
            ]"
            @click="goTo('lazer')"
          >
            <p>
              Preços especiais em viagens, hotéis, parques, lojas, restaurantes,
              academias e clubes.
            </p>
          </section>
        </div>
      </div>

      <div class="advantage__title">
        <h3>Descontos especiais do clube</h3>
      </div>
      <div class="limit-grid3">
        
        <section class="advantage__card">
          <figure>
            <img src="@/assets/beneficios/murumbi.svg" alt />
          </figure>
          <div class="advantage__card__text">
            <h4>10% de desconto no morumbi tour.</h4>
          </div>
        </section>
        <section class="advantage__card">
          <figure>
            <img src="@/assets/beneficios/restaurante-arabe.svg" alt />
          </figure>
          <div class="advantage__card__text">
            <h4>5% de desconto no restaurante árabe amani no morumbi.</h4>
          </div>
        </section>
        <section class="advantage__card">
          <figure>
            <img src="@/assets/beneficios/santo-manto.svg" alt />
          </figure>
          <div class="advantage__card__text">
            <h4>5% de desconto em qualquer produto na loja santo manto no morumbi.</h4>
            <p>
              <small>*Esse desconto não é válido em produtos promocionais</small>
            </p>
          </div>
        </section>
        <section class="advantage__card">
          <figure>
            <img src="@/assets/beneficios/360.svg" alt />
          </figure>
          <div class="advantage__card__text">
            <h4>Descontos em cursos na The 360°, uma escola com conteúdos para o mercado de futebol.</h4>
          </div>
        </section>
        <section class="advantage__card">
          <figure>
            <img src="@/assets/beneficios/n1.svg" alt />
          </figure>
          <div class="advantage__card__text">
            <h4>10% de desconto na conta da choperia<br/> nº1 no estádio do<br/> morumbi</h4>
            <p>
              <small>*Este desconto será aplicado individualmente ao filiado Cartão de TODOS São Paulo FC.</small>
            </p>
          </div>
        </section>
        <section class="advantage__card">
          <figure>
            <img src="@/assets/beneficios/loja-spmania.svg" alt />
          </figure>
          <div class="advantage__card__text">
            <h4>5% de desconto em qualquer produto</h4>
            <p>
              <small>nas lojas São Paulo Mania dos shoppings Aricanduva, Ibirapuera, SP Market e Tatuapé.</small>
            </p>
          </div>
        </section>
        <section class="advantage__card">
          <figure>
            <img src="@/assets/beneficios/sao-paulo-mania-online.svg" alt />
          </figure>
          <div class="advantage__card__text">
            <h4>5% de desconto</h4>
            <p>
              <small>em produtos na loja online São Paulo Mania, exceto em produtos da coleção 2021/2022 da Adidas.</small>
            </p>
          </div>
        </section>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  title() {
    return `Benefícios | Cartão de TODOS São Paulo`;
  },
  data() {
    return {
      itens: {
        saude: false,
        educacao: false,
        lazer: false
      }
    };
  },
  methods: {
    goTo(item) {
      switch (item) {
        case "saude":
          this.itens.saude = !this.itens.saude;
          this.itens.educacao = false;
          this.itens.lazer = false;
          break;
        case "educacao":
          this.itens.saude = false;
          this.itens.educacao = !this.itens.educacao;
          this.itens.lazer = false;
          break;
        case "lazer":
          this.itens.saude = false;
          this.itens.educacao = false;
          this.itens.lazer = !this.itens.lazer;
          break;
      }
    }
  }
};
</script>

<style lang="scss">
.advantage {
  padding-top: 68px;
  padding-bottom: 100px;
  background: $color-black;
  position: relative;
  z-index: 10;
  margin-bottom: -1px;
  @include media(">=tablet") {
    padding-top: 130px;
    padding-bottom: initial;
    margin-bottom: initial;
  }

  &__banner {
    position: relative;
    object-fit: cover;
    width: 100%;
    height: 204px;
    background: url("../assets/banners/banner-3-mobile.jpg") $color-black
      no-repeat top center;
    background-size: 100% auto;
    @include media(">=tablet") {
      height: 651px;
      background: url("../assets/banners/banner-3.jpg") $color-black no-repeat
        top center;
      background-size: cover;
    }
    h1 {
      padding-top: 25px;
      text-align: center;
      color: $color-white;
      font-family: "Arvo", sans-serif;
      font-weight: 700;
      font-size: 17px;
      line-height: 20px;
      text-transform: uppercase;
      @include media(">=tablet") {
        padding-top: 91px;
        font-size: 40px;
        line-height: 49px;
      }
    }
  }
  &__wrapper {
    position: relative;
  }
  &__grid {
    display: grid;
    grid-template-columns: repeat(3, 33.33%);
    position: relative;
    margin-top: -123px;
    @include media(">=tablet") {
      margin-top: -453px;
    }
    &__item {
      text-align: center;
      width: 100%;
      height: 100px;
      position: relative;
      background: $color-primary;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      @include media(">=tablet") {
        height: 366px;
      }
      img {
        max-height: 33px;
        flex: 1 0 100%;
        @include media(">=tablet") {
          max-height: 140px;
        }
      }
      &__wrapper {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        height: 58px;
        @include media(">=tablet") {
          height: 222.24px;
        }
        h2 {
          align-self: flex-end;
        }
      }
      &:nth-child(2) {
        background: $color-secondary;
        .advantage__grid__item__content {
          background: $color-secondary;
        }
      }
      &:last-child {
        background: $color-thirdy;
        .advantage__grid__item__content {
          background: $color-thirdy;
        }
      }
      h2 {
        color: $color-white;
        font-family: "Arvo", sans-serif;
        font-weight: 700;
        font-size: 9px;
        @include media(">=tablet") {
          font-size: 40px;
        }
      }
    }
    &-content {
      display: grid;
      grid-template-columns: 1fr;
      box-sizing: border-box;
      opacity: 1;
      transition: 0.3s ease-in-out;
      @include media(">=tablet") {
        position: absolute;
        top: 0;
        grid-template-columns: repeat(3, 33.33%);
        width: 100%;
        height: 366px;
      }

      &__item {
        opacity: 0;
        background: $color-primary;
        transition: 0.3s ease-in-out;
        overflow: hidden;
        max-height: 0;
        max-width: calc(100vw - 70px);
        @include media(">=tablet") {
          cursor: pointer;
          max-height: initial;
          max-width: initial;
          align-self: center;
        }
        &--active {
          opacity: 1;
          max-height: 500px;
        }
        &:nth-child(2) {
          background: $color-secondary;
        }
        &:last-child {
          background: $color-thirdy;
        }
        p {
          color: $color-white;
          // font-family: "Arvo", sans-serif;
          // font-weight: 700;
          text-align: left;
          font-size: 14px;
          line-height: 16px;
          padding: 20px;
          max-width: initial;
          @include media(">=tablet") {
            font-size: 20px;
            line-height: 28px;
            padding: 61px 33px;
            max-width: 318px;
          }
        }
      }
    }
  }

  &__title {
    margin: 30px 0 8px 0;
    @include media(">=tablet") {
      margin: 160px 0 43px 0;
    }
    h3 {
      text-align: center;
      color: $color-white;
      font-family: "Arvo", sans-serif;
      font-weight: 700;
      font-size: 17px;
      line-height: 20px;
      text-transform: uppercase;
      @include media(">=tablet") {
        font-size: 40px;
        line-height: 49px;
      }
    }
  }

  &__card {
    display: grid;
    grid-template-columns: 86px auto;
    grid-gap: 16px;
    background: $color-lightgray;
    text-align: center;
    height: initial;
    align-items: center;
    padding: 20px 12px;
    margin-top: 20px;
    @include media(">=tablet") {
      padding: 50px 45px 37px;
      min-height: 360px;
      grid-template-columns: 240px auto;
      grid-gap: 56px;
    }
    figure {
      margin: 0;
      img {
        max-width: 100%;
      }
    }

    &__text {
      text-align: left;
      max-width: 590px;
      &--small {
        font-size: 12px !important;
        line-height: 16px !important;
      }
      h4 {
        text-transform: uppercase;
        font-family: "Arvo", sans-serif;
        font-weight: 700;
        font-size: 18px;
        line-height: 21px;
        color: $color-primary;
        @include media(">=tablet") {
          font-size: 40px;
          line-height: 49px;
          margin-bottom: 23px;
        }
      }

      p {
        margin: 5px;
        font-size: 14px;
        line-height: 16px;
        color: $color-gray;
        margin-top: 0px;
        @include media(">=tablet") {
          font-size: 24px;
          line-height: 30px;
        }
        small {
          font-size: 12px;
          font-family: "Arvo", sans-serif;
          font-weight: normal;
          color: $color-black;
        }
      }
    }
  }
}
</style>
